// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.currentlyDraggingCss_cgtryd4{-webkit-user-select:none;user-select:none;}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-ui/dist/es/draggable-container/useDraggable.css"],"names":[],"mappings":"AAAA,8BAA8B,wBAAwB,CAA4C,gBAAgB,CAAC","sourcesContent":[".currentlyDraggingCss_cgtryd4{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
